import { Icon } from "@circle-react-shared/Icon";
import { Alert } from "@circle-react-uikit/AlertV2";

interface WarningAlertProps {
  className?: string;
  description: string;
  title: string;
}

export const WarningAlert = ({
  title,
  description,
  className = "",
}: WarningAlertProps) => (
  <Alert
    type="warning"
    icon={
      <Icon
        type="20-triangle-exclamation"
        size={20}
        className="mt-1 !self-start text-amber-600"
      />
    }
    title={title}
    description={description}
    className={`text-dark mb-4 mt-2 rounded-xl !border !border-amber-400 bg-[rgba(245,158,11,0.05)] [&_span]:!text-sm ${className}`}
  />
);
